var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prism-editor',{staticClass:"cms-editor",attrs:{"id":_vm.id,"highlight":_vm.highlighter,"line-numbers":true,"readonly":false},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }